import { createTableTree } from './create-table-tree';

// The balances slice is shaped by untyped JS actions and this file only
// re-nests it, so the parameters and the accumulator below are `any`.
export function balancesDataMapper(months: any) {
  const data = months?.map((month: any) => ({
    ...month,
    homesDetails: month.homesDetails.map((home: any) => {
      const {
        groupedBalancesPerCategory: { expenses, revenues, all },
      } = home;

      // Annotated because spreading an `any` contributes nothing to the literal's
      // type, so the three category assignments below would be writes to a
      // property TypeScript believes does not exist.
      const groups: any = { ...home, groupedBalancesPerCategory: {} };

      if (expenses) {
        groups.groupedBalancesPerCategory.expenses = {
          ...expenses,
          groupedBalancesInfo: createTableTree({
            data: expenses.groupedBalancesInfo,
            accessor: 'groupBalanceItemId',
            link: 'parentGroupBalanceItemId',
          }),
        };
      }

      if (revenues) {
        groups.groupedBalancesPerCategory.revenues = {
          ...revenues,
          groupedBalancesInfo: createTableTree({
            data: revenues.groupedBalancesInfo,
            accessor: 'groupBalanceItemId',
            link: 'parentGroupBalanceItemId',
          }),
        };
      }

      if (all) {
        groups.groupedBalancesPerCategory.all = {
          ...all,
          groupedBalancesInfo: createTableTree({
            data: all.groupedBalancesInfo,
            accessor: 'groupBalanceItemId',
            link: 'parentGroupBalanceItemId',
          }),
        };
      }

      return groups;
    }),
  }));

  return data;
}

export function underReviewDataMapper(balances: any) {
  return balances?.map((balance: any) => ({
    ...balance,
    groupedBalancesInfo: createTableTree({
      data: balance.groupedBalancesInfo,
      accessor: 'groupBalanceItemId',
      link: 'parentGroupBalanceItemId',
    }),
  }));
}
